import axiosInstance from 'services/api';
import getUserPreferences from './application/useCases/getUserPreferences';
import updateHighContrastMode from './application/useCases/updateHighContrastMode';
import RestUserPreferencesRepository from './infrastructure/restUserPreferencesRepository';

const userPreferencesRepository = new RestUserPreferencesRepository({ axiosInstance });

const getUserPreferencesUseCase = getUserPreferences({ userPreferencesRepository });
const updateHighContrastModeUseCase = updateHighContrastMode({ userPreferencesRepository });

export {
  getUserPreferencesUseCase as getUserPreferences,
  updateHighContrastModeUseCase as updateHighContrastMode,
};
